import { DefaultOptionType } from 'antd/lib/select';
import { InstitutionSearchLabel } from 'components/forms/InstitutionSearch/components';
import { SourceInstitution } from 'types/source-institution';

// type SourceInstitutionByHeading = {
//   key: string;
//   sourceInstitutions: SourceInstitution[];
// };

type ParentOption = Omit<DefaultOptionType, 'children' | 'value'> & {
  value: Required<DefaultOptionType['value']>;
  options: Array<ChildOption>;
};

type ChildOption = Omit<ParentOption, 'options'>;

export const RECENT_PREFIX = 'recent-';

/**
 * Gets all source insitutions and groups them by recent/country
 * and returns the JSX element to pass to Antd's Autocomplete.
 * @export
 * @param {string} searchTerm
 * @param {string[]} recentInstitutionIDs
 * @param {SourceInstitution[]} sourceInstitutions
 * @return {*}  {CountryOption[]}
 */
export function getOptions(
  searchTerm: string,
  recentInstitutionIDs: string[],
  sourceInstitutions: SourceInstitution[],
): ParentOption[] {
  const filteredBySearchTerm = sourceInstitutions.filter((sourceInstitution) =>
    [sourceInstitution.name, sourceInstitution.country].some((field) =>
      field.trim().toLowerCase().includes(searchTerm.trim().toLowerCase()),
    ),
  );
  const groupByHeading = filteredBySearchTerm.reduce<ParentOption[]>((options, sourceInstitution) => {
    if (recentInstitutionIDs.includes(sourceInstitution.ID)) {
      const recentOption = options.find((option) => option.value === 'recent');
      const newOption: ChildOption = {
        value: `${RECENT_PREFIX}${sourceInstitution.ID}`,
        label: (
          <InstitutionSearchLabel
            isRecent={true}
            countryLabel={sourceInstitution.country}
            nameLabel={sourceInstitution.name}
          />
        ),
      };
      if (recentOption) {
        recentOption.options?.push(newOption);
      } else {
        options.unshift({
          value: 'recent',
          label: (
            <div className='institution-search-heading'>
              <strong>{'RECENT'}</strong>
            </div>
          ),
          options: [newOption],
        });
      }
      return options;
    }
    const countryOption = options.find((option) => option.value === sourceInstitution.country);
    const newOption: ChildOption = {
      value: sourceInstitution.ID,
      label: (
        <InstitutionSearchLabel
          isRecent={false}
          countryLabel={sourceInstitution.country}
          nameLabel={sourceInstitution.name}
        />
      ),
    };
    if (countryOption) {
      countryOption.options.push(newOption);
    } else {
      options.push({
        value: sourceInstitution.country,
        label: (
          <div className='institution-search-heading'>
            <strong>{sourceInstitution.country.toUpperCase()}</strong>
          </div>
        ),
        options: [newOption],
      });
    }
    return options;
  }, []);
  const recentGroup = groupByHeading.find((group) => group.value === 'recent' && group.children);
  if (recentGroup) {
    // Maintain correct order of recent institutions
    recentGroup.options?.sort((a, b) =>
      recentInstitutionIDs.findIndex((ID) => ID === a.ID) > recentInstitutionIDs.findIndex((ID) => ID === b.ID)
        ? 1
        : -1,
    );
  }
  return groupByHeading.sort((a, b) => {
    if (b.value === 'recent') {
      return 1;
    }
    if (typeof a.value !== 'string' || typeof b.value !== 'string') {
      return 0;
    }
    return a.value.localeCompare(b.value);
  });
}
